<div class="container">

    <!--NUESTRA FILOSOFIA-->
    <div class="row nf animate__animated animate__fadeIn">
        <div class="col">
            <div class="title">
                <h2><span class="triidy-color">Nuestra Filosofía</span></h2>
            </div>
            <p>Triidy es una empresa con gran capacidad de cambio, que conecta el conocimiento de los más tesos, de los rebeldes, de esas personas que nunca paran de aprender, para crear, probar, medir y escalar servicios innovadores que beneficien a nuestra
                comunidad
            </p>
            <p>Conectar negocios y personas de latinoamérica con una economía digital basada en comercio social, brindando acceso a esquemas de marketing, producto, logística y finanzas
            </p>
            <p>La innovación continua tiene grandes retos, podemos equivocarnos, tomar malas decisiones o simplemente necesitar ayuda, por eso en Triidy le damos importancia a lo que dicen nuestros clientes. La retroalimentación positiva y constructiva es
                fundamental para afrontar el conflicto, brindar una solución oportuna y mejorar la experiencia al usuario
            </p>
            <p>
                La pasión por nuestro trabajo nos permite hacer cosas extraordinarias. Es lo que llamamos ADN Triidy
            </p>
        </div>
        <div class="col">
            <img class="adn-im" src="https://triidyftp.s3.us-east-2.amazonaws.com/Triidy_web/Gid-ADN.gif" alt="">
        </div>

    </div>

    <!--NUESTRA GENTE-->
    <div class="row" data-aos="zoom-in">
        <div class="title">
            <h2><span class="triidy-color">Nuestra Gente</span></h2>
        </div>
        <p class="ng">Somos un equipo de trabajo multidisciplinario, que busca constantemente mejorar en todos los aspectos. Juntos aceptamos desafíos, solucionamos problemas y creamos nuevos servicios que se acoplen a las necesidades de nuestros clientes, generando
            valor y fortaleciendo nuestra comunidad
        </p>
    </div>

    <!--EQUIPO-->
    <div class="row rcard">
        <div class="cards" *ngFor="let team of equipo" data-aos="zoom-in">
            <div class="image-area">
                <div class="img-wrapper">
                    <img src="{{team.foto}}" alt="Atul Prajapati">
                    <h2 [ngStyle]="{'background': team.color}">{{team.nombre}} <br> {{team.cargo}}</h2>
                    <ul>
                        <li><a [ngStyle]="{'color': team.color}" href="{{ team.linked }}"><i
                                    [ngStyle]="{'color': team.color}" class="fab fa-linkedin-in"></i></a></li>
                        <!--<li><a [ngStyle]="{'color': team.color}" href="https://www.instagram.com/"><i
                                    [ngStyle]="{'color': team.color}" class="fab fa-instagram"></i></a>
                        </li>
                        <li><a [ngStyle]="{'color': team.color}" href="https://twitter.com/"><i
                                    [ngStyle]="{'color': team.color}" class="fab fa-twitter"></i></a></li>-->
                        <!--<li><a href="https://www.youtube.com/"><i class="fab fa-youtube"></i></a>
                        </li>-->
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>